export default {
  sm: `
  The emergence of new technologies, such as the adoption of the internet, the development of mobile telecommunications, and the rise of the smartphones make people create and consume even more data.
  Data has now become the air that fills our daily lives.
  `
};
